'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _draftJs = require('draft-js');

var insertTexBlock = function insertTexBlock(editorState, texValue) {
  var contentStateWithEntity = editorState.getCurrentContent().createEntity('TEX', 'IMMUTABLE', { content: texValue });
  var entityKey = contentStateWithEntity.getLastCreatedEntityKey();
  var currentSelectionState = editorState.getSelection();

  // get selection of the @mention search text
  var mentionTextSelection = currentSelectionState.merge({
    anchorOffset: currentSelectionState.getStartOffset(),
    focusOffset: currentSelectionState.getStartOffset()
  });

  var newContentState = _draftJs.Modifier.insertText(contentStateWithEntity, mentionTextSelection, '-', null, entityKey);

  var newEditorState = _draftJs.EditorState.push(editorState, newContentState, 'insert-fragment');

  var selection2 = newEditorState.getSelection();

  var mentionTextSelection2 = selection2.merge({
    anchorOffset: currentSelectionState.getStartOffset(),
    focusOffset: currentSelectionState.getStartOffset()
  });

  var newContentState2 = _draftJs.Modifier.insertText(newEditorState.getCurrentContent(), mentionTextSelection2, '-');

  var newEditorState2 = _draftJs.EditorState.push(editorState, newContentState2, 'insert-characters');

  return _draftJs.EditorState.forceSelection(newEditorState2, newContentState2.getSelectionAfter());
};

exports.default = insertTexBlock;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/RichEditor/modifiers/insertTexBlock.js
// module id = 1189
// module chunks = 0